<template>
  <v-app>
    <platform-layout />
    <new-version />
    <screen-size-checker />
    <error-dialog />
  </v-app>
</template>

<script>
import { useTheme } from "vuetify";
import PlatformLayout from "@/layouts/Layout.vue";
import NewVersion from "@/components/NewVersion.vue";
import ScreenSizeChecker from "@/components/ScreenSizeChecker.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";
import { WebSocketStores, WebSocketChannels } from "@/lib/websocket/channels";
import { mapStores } from "pinia";
import { useUserStore } from "@/stores/UserStore";
import { useThemeStore } from "@/stores/ThemeStore";
import { userTierMixin } from "@/mixins/UserTier";
import { useErrorStore } from "@/stores/ErrorStore";
import { usePlatformFeatureEnforcement } from "@/composables/usePlatformFeatureEnforcement";

export default {
  components: {
    NewVersion,
    ScreenSizeChecker,
    PlatformLayout,
    ErrorDialog,
  },
  mixins: [userTierMixin],
  setup() {
    const theme = useTheme();
    usePlatformFeatureEnforcement();

    return {
      theme,
      updateTheme: (themeName) => {
        theme.change(themeName);
      },
    };
  },
  channels: WebSocketChannels,
  computed: {
    ...mapStores(
      useUserStore,
      useThemeStore,
      useErrorStore,
      ...WebSocketStores,
    ),
  },
  watch: {
    loggedIn(newState) {
      if (newState) {
        this.setTheme();
        this.initializeUserSettings();
      }
    },
    currentOrg(newValue, oldValue) {
      if (
        this.loggedIn &&
        this.themeName(newValue) !== this.themeName(oldValue)
      ) {
        this.setTheme();
      }
    },
    currentAppClient(newValue, oldValue) {
      if (
        this.loggedIn &&
        this.themeName(newValue) !== this.themeName(oldValue)
      ) {
        this.setTheme();
      }
    },
  },
  mounted() {
    if (this.$ws) {
      this.$ws.initialize(new Set(["SlackUserActivity"]));
    }
    if (this.loggedIn) {
      this.userStore.initialized = false;
      this.initializeUserSettings();
    } else {
      this.setTheme();
    }
  },
  methods: {
    themeName(entity) {
      return entity?.theme?.name;
    },
    setTheme() {
      let theme = undefined;
      if (this.loggedIn) {
        // Prefer org, then app client (matches UserMenu active selection), then user.
        theme =
          this.currentOrg?.theme?.name ||
          this.currentAppClient?.theme?.name ||
          this.currentUser.theme?.name ||
          "tunnl";
      } else {
        if (/\.deeprootanalytics\.com$/.test(window.location.hostname)) {
          theme = "deeproot";
        } else {
          theme = "tunnl";
        }
      }
      this.updateTheme(theme);
      this.themeStore.activeTheme = { name: theme };
    },
  },
};
</script>
